import { useState } from "react";
import { useSearchParams, useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { AccountShell } from "@/components/account";
import { useSeo } from "@/lib/seo";

export default function ResetPassword() {
  useSeo({ title: "Set a new password", path: "/reset-password", noindex: true });
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    if (password.length < 8) { toast.error("Password must be at least 8 characters."); return; }
    setBusy(true);
    try {
      await api.resetPassword(token, password);
      toast.success("Password updated — please sign in.");
      navigate("/login", { replace: true });
    } catch (err) {
      toast.error(err?.response?.data?.detail || "This reset link is invalid or has expired.");
    } finally {
      setBusy(false);
    }
  }

  if (!token) {
    return (
      <AccountShell title="Invalid link" subtitle="This reset link is missing or malformed.">
        <p className="auth-foot small"><Link to="/forgot-password" data-testid="reset-request-new">Request a new link</Link></p>
      </AccountShell>
    );
  }

  return (
    <AccountShell title="Set a new password" subtitle="Choose a new password for your account.">
      <form onSubmit={submit}>
        <div className="field"><label htmlFor="rp-password">New password</label>
          <input id="rp-password" data-testid="reset-password" type="password" autoComplete="new-password" required
            value={password} onChange={(e) => setPassword(e.target.value)} placeholder="At least 8 characters" /></div>
        <button className="btn blue auth-submit" data-testid="reset-submit" disabled={busy}>
          {busy ? "Saving…" : "Update password"}</button>
      </form>
    </AccountShell>
  );
}
